import React from 'react';

const JWTIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="70"
            height="70"
            viewBox="0.4 0.3 99.7 100"
        >
            <g fill="none" fillRule="evenodd">
                <path
                    fill="#fff"
                    d="M57.8 27.2L57.7.3h-15l.1 26.9 7.5 10.3zm-15 46.1v27h15v-27L50.3 63z"
                ></path>
                <path
                    fill="#00f2e6"
                    d="M57.8 73.3l15.8 21.8 12.1-8.8-15.8-21.8-12.1-3.9zm-15-46.1L26.9 5.4l-12.1 8.8L30.6 36l12.2 3.9z"
                ></path>
                <path
                    fill="#00b9f1"
                    d="M30.6 36L5 27.7.4 41.9 26 50.3l12.1-4zm31.8 18.2l7.5 10.3 25.6 8.3 4.6-14.2-25.6-8.3z"
                ></path>
                <path
                    fill="#d63aff"
                    d="M74.5 50.3l25.6-8.4-4.6-14.2L69.9 36l-7.5 10.3zm-48.5 0L.4 58.6 5 72.8l25.6-8.3 7.5-10.3z"
                ></path>
                <path
                    fill="#fb015b"
                    d="M30.6 64.5L14.8 86.3l12.1 8.8 15.9-21.8V60.6zM69.9 36l15.8-21.8-12.1-8.8-15.8 21.8v12.7z"
                ></path>
            </g>
        </svg>
    );
};

export default JWTIcon;